const FORM_TEXT = {
  REQUIRED_FR: 'Champ obligatoire',
  REQUIRED_EN: 'Required',
  REQUIRED_VALID_EMAIL_FR: 'Doit être une adresse e-mail valide',
  REQUIRED_VALID_EMAIL_EN: 'Must be a valid email address'
};

export default FORM_TEXT;
